import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface UpgradeFormOptions extends CommonOptions {
    formGlobs: string[];
    useCiBuild: boolean;
    engine: undefined | string;
    preid: undefined | string;
    skipPreVersions: boolean;
}

const localServerOptionsDefinition = optionsDefinition(
    {
        alias: "g",
        name: "gfvs",
        defaultValue: { formGlobs: [] },
        parse: (input: string[]) => ({ formGlobs: input }),
        defaultOption: true,
        multiple: true,
        description: "Одна или несколько GFV или GFV-масок для обновления.",
    },
    {
        name: "use-ci-build",
        doesNotRequireValue: true,
        defaultValue: { useCiBuild: false },
        parse: (x: boolean) => ({ useCiBuild: x }),
        description: "Приготовить форму к сборке на CI, без необходимости локальной пересборки.",
    },
    {
        name: "skip-pre-versions",
        doesNotRequireValue: true,
        defaultValue: { skipPreVersions: false },
        parse: (x: boolean) => ({ skipPreVersions: x }),
        description: "При обновлении версий форм не обновлять формы с нестабильными версиями.",
    },
    {
        name: "engine",
        defaultValue: { engine: undefined as string | undefined },
        parse: (x: string) => ({ engine: x }),
        description:
            "Обновляет движок до заданной версии. Можно использовать кокретную версию движка (например, 0.4.82) или latest, для обновления до последней стабильной версии.",
    },
    {
        name: "preid",
        defaultValue: { preid: undefined as string | undefined },
        parse: (x: string) => ({ preid: x }),
        description: "Обновляет движок до последней пререлизной версии указанной в preid.",
    },
    devModeOption,
    logVerbosityOption
);

export const upgradeFormCommandDefinition = commandDefinition<"upgrade", UpgradeFormOptions>(
    "upgrade",
    "upgrade",
    localServerOptionsDefinition,
    {
        description: "Обновление формата форм или режима одной или нескольких форм.",
        examples: `
### Перевод формы на сборку в CI

Выполнить:
\`\`\`
candy upgrade --use-ci-build 9900101
\`\`\`
Эта команда удалит и заигнорит генерируемые файлы в каталоге farm и поменит форму как собираемую на CI.
После этого не требуется далть комиты в репозиторий resources.

Обновлять версию движка формы надо командой:
\`\`\`
candy upgrade --engine latest 9900101
\`\`\`
`.trim(),
    }
);
